<script>
    import { createEventDispatcher } from 'svelte'
    import { Button } from '$lib/components/UI'
    export let label = ''
    export let size = 'default'
    export let style = ''
    export let direction = 'row'
    export let disabled = false
    export let type = 'primary'
    export let legend = '¿Está seguro de que desea confirmar esta acción?'
    const dispatch = createEventDispatcher()
    import Typography from '$lib/components/UI/Typography.svelte'
    
    let show = true
    function click() { dispatch('click', {}) }
    
    $: if(disabled) { show = false }
</script>

{#if show}
    <div class="content">
        <div style="flex-direction: {direction};">
            <Typography type="button" style="">{legend}</Typography>
            <span>
                <Button style="width:100%" size="small" {disabled} on:click={click}>Confirmar</Button>
                <Button style="width:100%" type="other" size="small" on:click={() => { show = false }}>Cancelar</Button>
            </span>
        </div>
    </div>
{:else}
    <Button {label} {size} {style} {disabled} {type} on:click={() => { show = true }}/>
{/if}

<style>
    .content {
        position: relative;
        height: fit-content;
        border-radius: 9px;
        border: 1px solid var(--color-grey-400);
    }
    div {
        display: flex;
        flex-direction: column;
        gap: 25px;
        padding: 0 10px;
        border-radius: 5px;
        background-color: var(--color-grey-100);
    }
    span {
        display: flex;
        flex-direction: row;
        gap: 15px;
        justify-content: space-between;
        align-items: center;
    }
</style>

